import axios from 'axios';
import lib from '@/lib';

export default class AreaModel {
	constructor() {
		this.farmListEditTroopsShow = false;
		this.farmListItemEditTroopsShow = false;
		this.farmListAddShow = false;
		this.farmListEditShow = false;
		this.farmListAddVillageShow = false;
		
		
	}
}
